import React from "react";
import { Link } from "react-router-dom";
import paths from "../../routes/paths";

function Footer() {
    return (
        <footer class="footer footer-center p-10 rounded font-quicksand pt-20" data-theme="weireframe">
            <div>
                <div className="grid grid-flow-col gap-4">
                    <Link to={paths.home} className="link link-hover" >Home</Link>
                    <Link to={paths.contact} className="link link-hover" >Contact</Link>
                    
                </div>
                
                <div>
                    <p>Copyright © {(new Date().getFullYear())} - All right reserved by Next Gadget Shop </p>
                </div>
            </div>
        </footer>
    );
}

export default Footer;